import WithRender from "../../templates/imageEditor/imageEditor.html";
import { mapGetters } from "vuex";

import Margintotal from "../imageEditor/Margintotal";
import LoadingEditor from "../imageEditor/LoadingEditor";
import CanvasEditor from "../imageEditor/CanvasEditor";
import EditorToolbar from "../imageEditor/EditorToolbar";

export default WithRender({
  components: {
    appMargintotal: Margintotal,
    appLoadingEditor: LoadingEditor,
    appCanvasEditor: CanvasEditor,
    appEditorToolbar: EditorToolbar
  },
  mounted: function () {
    this.$store.dispatch("initFormatPep");
    this.$store.dispatch("initSteckDosenClicks");
  }
});
